export const twistClassicTKeys = {
  ABOUT_HASH: "ABOUT_HASH",
  AUTOBET: "AUTOBET",
  FREE_BET: "FREE_BET",
  BALANCE: "BALANCE",
  BET: "BET",
  BET_AMOUNT: "BET_AMOUNT",
  CHECK: "CHECK",
  CHECK_HASH: "CHECK_HASH",
  HASH: "HASH",
  INFO_SECTION: "INFO_SECTION",
  INFO_SECTION_DESCRIPTION: "INFO_SECTION_DESCRIPTION",
  INSUFFICIENT_BALANCE: "INSUFFICIENT_BALANCE",
  KEY: "KEY",
  LAST_ROUND_ID: "LAST_ROUND_ID",
  LAST_ROUND_RESULT: "LAST_ROUND_RESULT",
  NEXT_ROUND: "NEXT_ROUND",
  NOTIFICATION_MAX_BET: "NOTIFICATION_MAX_BET",
  NOTIFICATION_MAX_TARGET_MULTIPLIER: "NOTIFICATION_MAX_TARGET_MULTIPLIER",
  NOTIFICATION_MIN_BET: "NOTIFICATION_MIN_BET",
  NOTIFICATION_MIN_TARGET_MULTIPLIER: "NOTIFICATION_MIN_TARGET_MULTIPLIER",
  NUMBER_OF_ROUNDS: "NUMBER_OF_ROUNDS",
  ODD: "ODD",
  PROVABLY_FAIRNESS: "PROVABLY_FAIRNESS",
  SALT: "SALT",
  START_AUTOBET: "START_AUTOBET",
  STOP_AUTOBET: "STOP_AUTOBET",
  TARGET_MULTIPLIER: "TARGET_MULTIPLIER",
  WIN_CHANCE: "WIN_CHANCE",
  PAYOUT: "PAYOUT",
  LAST_PAYOUT: "LAST_PAYOUT",
  YOU_WIN: "YOU_WIN",
  ABOUT_HASH_DESCRIPTION: "ABOUT_HASH_DESCRIPTION",
};
